/**
 * Helpers de convenio / grupo de empresas (maestro honorarios).
 */

/** True si la fila es convenio y no es el pagador del grupo. */
export function isConvenioCoveredMember(row) {
  if (String(row?.billing_condition || "").trim() !== "convenio") return false;
  const payer = String(row?.payer_fiscal_client_id || "").trim();
  const fid = String(row?.fiscal_client_id || "").trim();
  if (!payer || !fid) return false;
  return payer !== fid;
}

/** True si es el pagador (o convenio sin pagador definido = legado). */
export function isConvenioPayer(row) {
  if (String(row?.billing_condition || "").trim() !== "convenio") return false;
  const payer = String(row?.payer_fiscal_client_id || "").trim();
  const fid = String(row?.fiscal_client_id || "").trim();
  if (!payer) return true;
  return payer === fid;
}

export function convenioRoleLabel(row) {
  if (String(row?.billing_condition || "").trim() !== "convenio") return "";
  if (isConvenioCoveredMember(row)) return "Sin cobro";
  if (String(row?.payer_fiscal_client_id || "").trim()) return "Se factura a este";
  return "";
}
